import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Main from './Main';
import Spinner from './common/Spinner';
import { persistor, store } from './configureStore';

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={<Spinner />} persistor={persistor}>
          <Main />
        </PersistGate>
      </Provider>
    );
  }
}
